// import React from 'react';
// import { Link } from 'react-router-dom';
// import { useLanguage } from '../../context/LanguageContext';

// const highlights = [
//   { icon: 'bi-mic-fill', label: 'Oratory & Debate', labelMr: 'वक्तृत्व' },
//   { icon: 'bi-music-note-beamed', label: 'Classical Dance', labelMr: 'कथक नृत्य' },
//   { icon: 'bi-pen-fill', label: 'Writing', labelMr: 'लेखन' },
//   { icon: 'bi-book-fill', label: 'Voracious Reader', labelMr: 'वाचन' },
// ];

// const HomeAboutPreview = () => {
//   const { t, language } = useLanguage();

//   return (
//     <section className="section-pad" id="about-preview">
//       <div className="container">
//         <div className="row align-items-center g-5">

//           {/* ── Left: Image grid ── */}
//           <div className="col-lg-5">
//             <div className="img-grid-wrap">
//               <div className="img-grid-dot-decor"></div>
//               <div className="img-grid-2col">

//                 <div className="img-grid-main">
//                   <img
//                     src="/assets/images/549.jpg.jpeg"
//                     alt="Chaitralee"
//                     style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
//                   />
//                 </div>

//                 <div className="img-grid-sm">
//                   <img
//                     src="/assets/images/767.jpg.jpeg"
//                     alt="Chaitralee"
//                     style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
//                   />
//                 </div>

//                 <div className="img-grid-sm">
//                   <img
//                     src="/assets/images/700.jpg.jpeg"
//                     alt="Chaitralee"
//                     style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
//                   />
//                 </div>

//               </div>

//               {/* Floating quote card */}
//               <div className="float-card-primary" style={{ position: 'absolute', bottom: '-1.5rem', right: '-1.25rem', maxWidth: '210px', zIndex: 2 }}>
//                 <div className="float-quote-text">"मी आहे... मी इथेच आहे!"</div>
//                 <div className="float-quote-sub">— चैत्राली इंदोरे</div>
//               </div>
//             </div>
//           </div>

//           {/* ── Right: Content ── */}
//           <div className="col-lg-7">
//             <span className="eyebrow">
//               <i className="bi bi-flower2 me-2"></i>
//               {t('common.sheIs')}
//             </span>

//             <h2 className="section-title">{t('home.aboutTitle')}</h2>
//             <div className="divider-brand"></div>

//             <p className="body-text">{t('home.aboutText')}</p>

//             {/* Mini highlights */}
//             <div className="row g-2 mb-4">
//               {highlights.map(({ icon, label, labelMr }) => (
//                 <div className="col-6" key={label}>
//                   <div className="d-flex align-items-center gap-2 p-2 rounded-3 bg-card border border-site">
//                     <i className={`bi ${icon} text-brand`} style={{ fontSize: '1rem' }}></i>
//                     <span className="font-sans text-sub" style={{ fontSize: '0.85rem', fontWeight: 500 }}>
//                       {language === 'mr' ? labelMr : label}
//                     </span>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <Link to="/who-is-chaitralee" className="btn-brand">
//               {t('home.aboutCta')}
//               <i className="bi bi-arrow-right"></i>
//             </Link>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default HomeAboutPreview;


import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const highlights = [
  { icon: 'bi-mic-fill',           label: 'Oratory & Debate',  labelMr: 'वक्तृत्व'   },
  { icon: 'bi-music-note-beamed',  label: 'Classical Dance',   labelMr: 'कथक नृत्य' },
  { icon: 'bi-pen-fill',           label: 'Writing',           labelMr: 'लेखन'       },
  { icon: 'bi-book-fill',          label: 'Voracious Reader',  labelMr: 'वाचन'       },
];

const HomeAboutPreview = () => {
  const { t, language } = useLanguage();

  return (
    <>
      <style>{`
        /* ═══════════════════════════════════════
           3-PHOTO FAN — all visible by default
        ═══════════════════════════════════════ */
        .pf-wrap {
          position: relative;
          width: 100%;
          max-width: 380px;
          margin: 0 auto;
          padding-bottom: 72px;
        }

        /* Dot grid accent */
        .pf-dots {
          position: absolute;
          top: -20px;
          left: -20px;
          width: 80px;
          height: 80px;
          background-image: radial-gradient(circle, rgba(140,50,60,0.18) 1.5px, transparent 1.5px);
          background-size: 10px 10px;
          z-index: 0;
          pointer-events: none;
        }

        /* ── Polaroid card base ── */
        .pf-card {
          position: absolute;
          width: 200px;
          background: #fff;
          border-radius: 4px;
          padding: 7px 7px 26px 7px;
          box-shadow: 0 6px 24px rgba(0,0,0,0.15), 0 2px 6px rgba(0,0,0,0.10);
          transition: transform 0.5s cubic-bezier(0.22,1,0.36,1),
                      box-shadow 0.4s ease;
        }
        .pf-card img {
          width: 100%;
          aspect-ratio: 4 / 5;
          object-fit: cover;
          display: block;
          border-radius: 2px;
        }
        .pf-year-tag {
          position: absolute;
          bottom: 5px;
          left: 0; right: 0;
          text-align: center;
          font-size: 0.58rem;
          font-family: 'Courier New', monospace;
          letter-spacing: 0.08em;
          color: #b0856a;
          user-select: none;
        }

        /* ── Default positions: all 3 visible, spread apart ── */

        /* Left card */
        .pf-card-back {
          top: 30px;
          left: 0px;
          transform: rotate(-10deg);
          z-index: 1;
        }
        /* Center card — slightly raised */
        .pf-card-mid {
          top: 0px;
          left: 50%;
          transform: translateX(-50%) rotate(-1deg);
          z-index: 3;
        }
        /* Right card */
        .pf-card-front {
          top: 30px;
          right: 0px;
          transform: rotate(9deg);
          z-index: 2;
        }

        /* ── Hover: fan out more + lift ── */
        .pf-wrap:hover .pf-card-back {
          transform: rotate(-16deg) translateY(-10px) translateX(-10px);
          box-shadow: 0 16px 40px rgba(0,0,0,0.22);
        }
        .pf-wrap:hover .pf-card-mid {
          transform: translateX(-50%) rotate(0deg) translateY(-18px);
          box-shadow: 0 24px 52px rgba(0,0,0,0.28);
          z-index: 4;
        }
        .pf-wrap:hover .pf-card-front {
          transform: rotate(16deg) translateY(-10px) translateX(10px);
          box-shadow: 0 16px 40px rgba(0,0,0,0.22);
        }

        /* Spacer for height */
        .pf-spacer {
          display: block;
          height: calc(200px * 1.25 + 60px + 30px);
        }

        /* ── Quote bubble ── */
        .pf-quote {
          position: absolute;
          bottom: 0;
          right: 0px;
          max-width: 190px;
          z-index: 5;
          background: #7b1d3a;
          border-radius: 14px 14px 14px 4px;
          padding: 11px 15px;
          box-shadow: 0 8px 28px rgba(123,29,58,0.35);
        }
        .pf-quote-text {
          font-family: 'Georgia', serif;
          font-style: italic;
          font-size: 0.78rem;
          color: rgba(255,235,200,0.95);
          line-height: 1.5;
          margin-bottom: 4px;
        }
        .pf-quote-sub {
          font-size: 0.66rem;
          color: rgba(255,200,180,0.70);
          letter-spacing: 0.04em;
        }

        /* ── Responsive ── */
        @media (max-width: 991px) {
          .pf-wrap   { max-width: 320px; }
          .pf-card   { width: 170px; }
          .pf-spacer { height: calc(170px * 1.25 + 60px + 30px); }
        }
        @media (max-width: 575px) {
          .pf-wrap   { max-width: 280px; }
          .pf-card   { width: 145px; }
          .pf-spacer { height: calc(145px * 1.25 + 60px + 30px); }
        }
      `}</style>

      <section className="section-pad" id="about-preview">
        <div className="container">
          <div className="row align-items-center g-5">

            {/* ── Left: Fan photos ── */}
            <div className="col-lg-5 d-flex justify-content-center">
              <div className="pf-wrap">

                <div className="pf-dots" aria-hidden="true" />

                {/* Left photo */}
                <div className="pf-card pf-card-back">
                  <img src="/assets/images/700.jpg.jpeg" alt="Chaitralee" />
                  <div className="pf-year-tag">2023</div>
                </div>

                {/* Center photo (tallest / front) */}
                <div className="pf-card pf-card-mid">
                  <img src="/assets/images/549.jpg.jpeg" alt="Chaitralee" />
                  <div className="pf-year-tag">चैत्राली · 2005–2024</div>
                </div>

                {/* Right photo */}
                <div className="pf-card pf-card-front">
                  <img src="/assets/images/504.jpg.jpeg" alt="Chaitralee" />
                  <div className="pf-year-tag">2023</div>
                </div>

                <span className="pf-spacer" aria-hidden="true" />

                {/* Quote bubble */}
                <div className="pf-quote">
                  <div className="pf-quote-text">"मी आहे... मी इथेच आहे!"</div>
                  <div className="pf-quote-sub">— चैत्राली इंदोरे</div>
                </div>

              </div>
            </div>

            {/* ── Right: Content (unchanged) ── */}
            <div className="col-lg-7">
              <span className="eyebrow">
                <i className="bi bi-flower2 me-2"></i>
                {t('common.sheIs')}
              </span>

              <h2 className="section-title">{t('home.aboutTitle')}</h2>
              <div className="divider-brand"></div>

              <p className="body-text">{t('home.aboutText')}</p>

              <div className="row g-2 mb-4">
                {highlights.map(({ icon, label, labelMr }) => (
                  <div className="col-6" key={label}>
                    <div className="d-flex align-items-center gap-2 p-2 rounded-3 bg-card border border-site">
                      <i className={`bi ${icon} text-brand`} style={{ fontSize: '1rem' }}></i>
                      <span className="font-sans text-sub" style={{ fontSize: '0.85rem', fontWeight: 500 }}>
                        {language === 'mr' ? labelMr : label}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <Link to="/who-is-chaitralee" className="btn-brand">
                {t('home.aboutCta')}
                <i className="bi bi-arrow-right"></i>
              </Link>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default HomeAboutPreview;